import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { enqueueRequestErrorSnackbar, enqueueSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';
import i18next from 'i18next';

const name = 'regenerateCertificate';

type RegenerateCertificateParams = {
  accreditationId: string;
  afterSuccess?: () => void;
};
export const regenerateCertificate = createAsyncThunk(
  `${name}/post`,
  async ({ accreditationId, afterSuccess }: RegenerateCertificateParams, { dispatch }) => {
    try {
      await axios.post(`/api/v1/accreditations/${accreditationId}/regenerate-certificate`);

      dispatch(
        enqueueSnackbar({
          message:
            i18next.t(
              'newDashboard.certifications.certificateRefreshRequestSent',
              'Certificate refresh request sent'
            ) || 'Certificate refresh request sent',
          options: {
            variant: 'success'
          }
        })
      );
      afterSuccess && afterSuccess();
    } catch (error) {
      dispatch(enqueueRequestErrorSnackbar());
      throw error;
    }
  }
);
